import { Injectable } from '@angular/core';

import { TaskMapper } from '../contracts/task-mapper.contract';
import { TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

@Injectable()
export class HealthCheckInTaskMapper implements TaskMapper<TaskType.HealthCheckIn> {
  readonly type = TaskType.HealthCheckIn;

  map(r: TaskResponse): TaskDataMap[TaskType.HealthCheckIn] {
    const result = r.data?.['result'];

    return {
      memberId: r.data?.['memberId'] ?? '',
      memberName: r.data?.['memberName'] ?? '',
      result: result === 'Improved' || result === 'Worsened' ? result : 'Unchanged',
      comment: r.data?.['comment'] ?? '',
    };
  }
}
